import {
    REQUEST_MERCHANT,
    RECEIVE_MERCHANT,
    RECEIVE_MERCHANT_ERROR,
    RESET_MERCHANT,
} from '../actions/discountServiceTypes.js';

export const initState = {
    fetching: false,
    fetched: false,
    error: null,
    /** `{id, name, urlname, backendType}` — **use `urlname`** for cds and `/data/*` paths. */
    merchant: null,
    /** The `user.group.Id` this was resolved for, so an org switch invalidates it. */
    groupId: null,
    lastUpdated: null,
};

export default function merchants(state = initState, action) {
    switch (action.type) {
        case REQUEST_MERCHANT:
            return { ...state, fetching: true, fetched: false, error: null };
        case RECEIVE_MERCHANT:
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: null,
                merchant: action.merchant,
                groupId: action.groupId,
                lastUpdated: action.receivedAt,
            };
        case RECEIVE_MERCHANT_ERROR:
            console.error(action.error);
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.error.toString(),
                merchant: null,
            };
        case RESET_MERCHANT:
            return { ...initState };
        default:
            return state;
    }
}
